import { MoovConfigurationDTO } from "./moovConfigurationDTO";
import { MoovFileDTO } from "./moovFileDTO";
import { MoovStepInstanceDTO } from "./moovStepInstanceDTO";

export class MoovInstanceDTO{
    public id!:number;
    public customerId!:number;
    public moovConfiguration!:MoovConfigurationDTO;
    public triggerFile?:MoovFileDTO;
    public sourceFile!:MoovFileDTO;
    public resultFile!:MoovFileDTO;
    public collatedFiles?:MoovFileDTO[];
    public failedTrigger?:boolean;
    public failedTriggerReason?:string;
    public status!:number;
    public configurationStatus!:number;
    public collisionId?:string;
    public added!:string;
    public updated?:string;
    public executeOnOrAfter?:string;
    public startedAt?:string;
    public completedAt?:string;
    public stepInstances!: MoovStepInstanceDTO[];
    public addedByUserId?:number;
    public remarks?:string;

    constructor(){
        this.stepInstances=[];
        this.collatedFiles=[];
    }
}